import { Grid } from '@mui/material';
import '../../../App.css';
import colorData from '../../../json/color.json';
import useWindowSize from '../../../hooks/useWindowsSize';
import { useEffect, useState } from 'react';

type props = {
  label: string;
  value: string;
}
/**
 * グリッドコンポーネント
 * @param label string
 * @param value string
 * @returns 
 */
const ImformationGrid: React.FC<props> = ({ label, value }) => {
  const [width] = useWindowSize();
  const [isWide, setisWide] = useState(true);

  useEffect(() => {
    if (width === 0) {
        return setisWide(true);
    }
    if (width < 920) {
        return setisWide(false);
    }
    return setisWide(true);
}, [width]);
  
  const gridLabelStyle = {
    borderRight: `5px solid ${colorData['royalblue']}`,
    textAlign: 'left',
    paddingLeft: '100px',
    fontSize: '18px',
    lineHeight: 2
  }
  const gridLabelStyleSp = {
    borderBottom: `2px solid ${colorData['royalblue']}`,
    textAlign: 'left',
    paddingLeft: '20px',
    fontSize: '18px',
    lineHeight: 2,
    paddingTop: '20px'
  }
  const gridValueStyle = {
    textAlign: 'left',
    paddingLeft: isWide ? '100px' : '30px',
    fontSize: '18px',
    whiteSpace: 'pre-wrap',
    lineHeight: 2
  }
  return (
    <>
      <Grid item xs={12} md={3} sx={isWide ? gridLabelStyle : gridLabelStyleSp}>
        {label}
      </Grid>
      <Grid item xs={12} md={9} sx={gridValueStyle}>
        {value}
      </Grid>
    </>
  );

}

export default ImformationGrid;
